module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700italic.27139953.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700italic.ttf
// module id = 493
// module chunks = 0